import styled from 'styled-components';
import { breakpoints } from 'variables';

export const TechnologyContainer = styled.div`
   ${breakpoints.lg`
      margin-top: 60px;
   `}
`;
